import { useState } from 'react'
import { Box, Collapse, IconButton, useTheme } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ButtonBasic from '../buttons/ButtonBasic';
import FechaFunction from '../../function/FechaFunction';
import TextInfoTicket from '../text/TextInfoTicket';
import { showModal } from 'react-redux-modal-provider';
import ModalEditTareaCalendario from '../../modals/ticket/ModalEditTareaCalendario';

const ListTarea = ({
    tarea,
    traerTareas
})=>{
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [open, setOpen] = useState(false)
    const onOpenTareaEdit = () => {
        showModal(ModalEditTareaCalendario,{item: tarea, traerTareas: traerTareas})
    }
    return (
        <Box pl={2} pr={2} mt={1} mb={1}>
            <ButtonBasic
                onClick={()=>setOpen(!open)}
                fullWidth
                textButton={` #${tarea?.id_t} - ${tarea?.tipo_tarea?.nombre_tt}`}
                sx={{
                    background: isDarkMode ? '#2d3a52' : '#fff',
                    color: isDarkMode ? '#e0e0e0' : '#000',
                    border: 1,
                    borderColor: isDarkMode ? '#3d4a62' : 'gray',
                    marginBottom: 1,
                    '&:hover':{
                        background: isDarkMode ? '#3d4a62' : '#d1d1d1',
                        border: 1,
                        borderColor: isDarkMode ? '#3d4a62' : 'gray',
                    }
                }}
            />
            <Collapse in={open} sx={{border:1,borderColor: isDarkMode ? '#3d4a62' : '#dfe2e6',borderRadius:3,boxShadow:3,background: isDarkMode ? '#2d3a52' : '#fff'}}>
                <Box p={1.2} sx={{position:'relative'}}>
                    <TextInfoTicket
                        titulo='Estado'
                        descripcion={(tarea?.estado_tarea?.nombre_et === 'REPROGRAMADO' && tarea?.observaciones_t === 'CRM')
                            ? 'INSERTAR FECHA'
                            : tarea?.estado_tarea?.nombre_et
                        }
                    />
                    {tarea && tarea?.motivoReprogramadoObservaciones_t &&(
                        <TextInfoTicket titulo='Motivo Reprogramado' descripcion={tarea?.motivoReprogramadoObservaciones_t} />
                    )}
                    {tarea && tarea?.fecha_t &&(
                        <TextInfoTicket titulo='Fecha' descripcion={FechaFunction.format(tarea?.fecha_t, 'dd/MM/yyyy')} />
                    )}
                    <TextInfoTicket titulo='Horario' descripcion={`${tarea?.horaIni_t || ''} - ${tarea?.horaFin_t || ''}`} />
                    {tarea && tarea?.clienteLatitud_t &&(
                        <TextInfoTicket titulo='Latitud' descripcion={tarea?.clienteLatitud_t} />
                    )}
                    {tarea && tarea?.clienteLongitud_t &&(
                        <TextInfoTicket titulo='Longitud' descripcion={tarea?.clienteLongitud_t} />
                    )}
                    {tarea && tarea?.descripcion_t && tarea?.descripcion_t?.length > 1 &&(
                        <TextInfoTicket titulo='Observación' descripcion={tarea?.descripcion_t} />
                    )}
                    {tarea && tarea?.createdAt_t &&(
                        <TextInfoTicket titulo='Creado' descripcion={FechaFunction.format(new Date(tarea?.createdAt_t), 'dd/MM/yyyy HH:mm:ss')} />
                    )}
                    {/* Sección de acciones mejorada */}
                    <Box 
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mt: 2,
                            pt: 1.5,
                            borderTop: isDarkMode ? '1px solid #3d4a62' : '1px solid rgba(0, 0, 0, 0.1)',
                            background: isDarkMode ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)' : 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
                            borderRadius: 2,
                            padding: '12px 16px',
                            margin: '16px -8px -8px -8px'
                        }}
                    >
                        <Box 
                            component="a"
                            href={`http://calendario.nubicom.com.ar/tareas/${tarea?.id_t}/editar`}
                            target='_blank'
                            rel="noreferrer"
                            sx={{
                                textDecoration: 'none',
                                color: isDarkMode ? '#90caf9' : '#0364FF',
                                fontSize: 14,
                                fontWeight: 500,
                                display: 'flex',
                                alignItems: 'center',
                                '&:hover': {
                                    color: isDarkMode ? '#64B5F6' : '#0247B5',
                                    textDecoration: 'underline'
                                },
                                transition: 'all 0.2s ease'
                            }}
                        >
                            📅 Ir al Calendario
                        </Box>
                        <IconButton
                            size="small"
                            sx={{
                                backgroundColor: isDarkMode ? 'rgba(144, 202, 249, 0.1)' : 'rgba(3, 100, 255, 0.1)',
                                '&:hover': {
                                    backgroundColor: isDarkMode ? 'rgba(144, 202, 249, 0.2)' : 'rgba(3, 100, 255, 0.2)',
                                    transform: 'scale(1.1)'
                                },
                                transition: 'all 0.2s ease',
                                ml: 1
                            }}
                            onClick={()=>onOpenTareaEdit()}
                        >
                            <EditIcon sx={{color: isDarkMode ? '#90caf9' : '#0364FF', fontSize: 16}} />
                        </IconButton>
                    </Box>
                </Box>
            </Collapse>
        </Box>
    )
}

export default ListTarea